import React from 'react';
import { isMobile } from 'react-device-detect';
import Lottie from 'react-lottie-player';
import { useNavigate } from 'react-router-dom';

import * as animacao from './intro.json';

const Intro = (): React.ReactElement => {
  const navegacao = useNavigate();

  return (
    <div
      className="bg-dark d-flex justify-content-center align-items-center animate__animated animate__fadeIn"
      style={{ height: isMobile ? window.outerHeight : window.innerHeight }}
    >
      <Lottie
        play
        loop={false}
        animationData={animacao}
        style={{ width: '1500px' }}
        onComplete={() => navegacao('/estudar')}
        renderer={'canvas' as 'svg'}
      />
    </div>
  );
};

export default Intro;
